import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APITipiContratti {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }


    async initInsert(user) {

        let formData = new FormData();

        formData.append("username", user);

        return axios.post(this.getUrlDomain("TwoRecruitRegioniInitInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async insertTipoContratto(tipo_contratto, user) {

        let formData = new FormData();

        formData.append("username", user);

        for (var key in tipo_contratto) {
            formData.append(key, tipo_contratto[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitContractTypeInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initEdit(id, user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitContractTypeInitEditApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }


    async updateTipoContratto(tipo_contratto, user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);

        for (var key in tipo_contratto) {
            formData.append(key, tipo_contratto[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitContractTypeUpdApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async deleteTipoContratto(user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);


        return axios.post(this.getUrlDomain("TwoRecruitContractTypeDelApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initFilter(user) {

        let formData = new FormData();

        formData.append("username", user);


        return axios.post(this.getUrlDomain("TwoRecruitContractTypeInitFilterApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async checkCode(user, code) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("code", code);


        return axios.post(this.getUrlDomain("TwoRecruitContractTypeVerCodeApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async checkCodeNew(user, code, companyid) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("code", code);
        formData.append("companyid", companyid);


        return axios.post(this.getUrlDomain("TwoRecruitContractTypeVerCodeApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }



}

export default new APITipiContratti({
    url: "https://services.ebadge.it/public/api/"
})
